import { IRoute } from "../../../common/helpers/routesMapper";
import { connect } from "react-redux";
import withRouter from "../../utils/withRouter";
import injectIntl from "../../../common/helpers/injectIntl";

import { get } from "../../actions/general";
import taskCompleted from "../../store/plan/actions/taskCompleted";
import { changeStudentColors, changeStudentPitchNotation, changeStudentRhythmSyllableTypes, changeStudentReversedToneset, changeStudentSolfaAudio, changeStudentSolfaShort, changeStudentSolfaKam } from "../../store/user/actions";

import { seo } from "../../../common/helpers/seo";

import Join from "./lazy";
import { Store } from "redux";

const mapDispatchToProps = {
    get,
    taskCompleted,
    changeStudentColors,
    changeStudentPitchNotation,
    changeStudentRhythmSyllableTypes,
    changeStudentReversedToneset,
    changeStudentSolfaShort,
    changeStudentSolfaAudio,
    changeStudentSolfaKam,
};

export default {
    component: withRouter(connect(null, mapDispatchToProps)(injectIntl(Join))),
    renderSeo: (store: Store, allMessage: {[key: string]: string}, lang: string) => {
        return seo({ title: allMessage.classroom, allMessage, lang });
    },
} satisfies IRoute;
